import { ligainicial } from "./rutainicial.js";

const ligabase = ligainicial + "2022/Inv/";

export const invitaciones2022 = [
    {
        'numInvitacion' : 'SOPOT-GEH-FAFEF-ITP-8/2022',
        'procedimiento' : [
            {
                'numProc' : 'Procedimiento de Invitación a Cuando Menos Tres Personas núm. SOPOT-GEH-FAFEF-ITP-8/2022',
                'vigenciaProc' : 'Vigencia: 18 de agosto de 2022 (único día)',
                'descripcionProc' : 'Reconstrucción de la calle Zeuz, en Mineral de la Reforma; ubicada en la localidad de PRI Chacón, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                'urlAnexosProc' : `${ ligabase }8/8.rar`,
                'resultadosProc' : [
                    {
                        'resultado' : 'Junta de Aclaraciones',
                        'urlResultado' : `${ ligabase }8/JA8.pdf`,
                    },
                    {
                        'resultado' : 'Apertura de Proposiciones',
                        'urlResultado' : `${ ligabase }8/AP8.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlResultado' : `${ ligabase }8/FA8.pdf`,
                    },
                ]
            }
        ]
    },
    {
        'numInvitacion' : 'SOPOT-GEH-FAFEF-ITP-7/2022',
        'procedimiento' : [
            {
                'numProc' : 'Procedimiento de Invitación a Cuando Menos Tres Personas núm. SOPOT-GEH-FAFEF-ITP-7/2022',
                'vigenciaProc' : 'Vigencia: 9 de agosto de 2022 (único día)',
                'descripcionProc' : 'Rehabilitación de ciclopista tramo 2, (guarniciones, andadores y puentes); ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexosProc' : `${ ligabase }7/7.rar`,
                'resultadosProc' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlResultado' : `${ ligabase }7/JA7.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlResultado' : `${ ligabase }7/AMD7.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlResultado' : `${ ligabase }7/AP7.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlResultado' : `${ ligabase }7/FA7.pdf`,
                    },
                ]
            }
        ]
    },
    {
        'numInvitacion' : 'SOPOT-GEH-FAFEF-ITP-6/2022',
        'procedimiento' : [
            {
                'numProc' : 'Procedimiento de Invitación a Cuando Menos Tres Personas núm. SOPOT-GEH-FAFEF-ITP-6/2022',
                'vigenciaProc' : 'Vigencia: 9 de agosto de 2022 (único día)',
                'descripcionProc' : 'Rehabilitación de ciclopista tramo 1, (guarniciones, andadores y puentes); ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexosProc' : `${ ligabase }6/6.rar`,
                'resultadosProc' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlResultado' : `${ ligabase }6/JA6.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlResultado' : `${ ligabase }6/AMDJA6.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlResultado' : `${ ligabase }6/AP6.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlResultado' : `${ ligabase }6/FA6.pdf`,
                    },
                ]
            }
        ]
    },
    {
        'numInvitacion' : 'SOPOT-GEH-FAFEF-ITP-5/2022',
        'procedimiento' : [
            {
                'numProc' : 'Procedimiento de Invitación a Cuando Menos Tres Personas núm. SOPOT-GEH-FAFEF-ITP-5/2022',
                'vigenciaProc' : 'Vigencia: 13 de junio de 2022 (único día)',
                'descripcionProc' : 'Pavimentación hidráulica de calle Santa Rosa, colonia San Cayetano, municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexosProc' : `${ ligabase }5/5.rar`,
                'resultadosProc' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlResultado' : `${ ligabase }5/JA5.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlResultado' : `${ ligabase }5/AMDJA5.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlResultado' : `${ ligabase }5/AP5.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlResultado' : `${ ligabase }5/FA5.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlResultado' : `${ ligabase }5/AMDFA5.pdf`,
                    },
                ]
            }
        ]
    },
    {
        'numInvitacion' : 'SOPOT-GEH-FAFEF-ITP-4/2022',
        'procedimiento' : [
            {
                'numProc' : 'Procedimiento de Invitación a Cuando Menos Tres Personas núm. SOPOT-GEH-FAFEF-ITP-4/2022',
                'vigenciaProc' : 'Vigencia: 13 de junio de 2022 (único día)',
                'descripcionProc' : 'Rehabilitación de avenida Morelos, entre Av. Reforma y Av. Zaragoza, colonia Centro, municipio de Apan; ubicada en la localidad y Municipio de Apan, Estado de Hidalgo.',
                'urlAnexosProc' : `${ ligabase }4/4.rar`,
                'resultadosProc' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlResultado' : `${ ligabase }4/JA4.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlResultado' : `${ ligabase }4/AMDJA4.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlResultado' : `${ ligabase }4/AP4.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlResultado' : `${ ligabase }4/FA4.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlResultado' : `${ ligabase }4/AMDFA4.pdf`,
                    },
                ]
            }
        ]
    },
    {
        'numInvitacion' : 'SOPOT-GEH-FAFEF-ITP-3/2022',
        'procedimiento' : [
            {
                'numProc' : 'Procedimiento de Invitación a Cuando Menos Tres Personas núm. SOPOT-GEH-FAFEF-ITP-3/2022',
                'vigenciaProc' : 'Vigencia: 13 de junio de 2022 (único día)',
                'descripcionProc' : 'Construcción de pavimentación de Av. Metztitlán, Col. Centro, municipio de Metztitlán; ubicada en la localidad y Municipio de Metztitlán, Estado de Hidalgo.',
                'urlAnexosProc' : `${ ligabase }3/3.rar`,
                'resultadosProc' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlResultado' : `${ ligabase }3/JA3.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlResultado' : `${ ligabase }3/AP3.pdf`,
                    },
                ]
            }
        ]
    },
    {
        'numInvitacion' : 'SOPOT-GEH-FAFEF-ITP-2/2022',
        'procedimiento' : [
            {
                'numProc' : 'Procedimiento de Invitación a Cuando Menos Tres Personas núm. SOPOT-GEH-FAFEF-ITP-2/2022',
                'vigenciaProc' : 'Vigencia: 13 de junio de 2022 (único día)',
                'descripcionProc' : 'Pavimentación de calle de acceso principal a Tlaltepingo, municipio de Lolotla; ubicada en la localidad de Tlaltepingo, Municipio de Lolotla, Estado de Hidalgo.',
                'urlAnexosProc' : `${ ligabase }2/2.rar`,
                'resultadosProc' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlResultado' : `${ ligabase }2/JA2.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlResultado' : `${ ligabase }2/AMDJA2.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlResultado' : `${ ligabase }2/AP2.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlResultado' : `${ ligabase }2/FA2.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlResultado' : `${ ligabase }2/AMDFA2.pdf`,
                    },
                ]
            }
        ]
    },
    {
        'numInvitacion' : 'SOPOT-GEH-FAFEF-ITP-1/2022',
        'procedimiento' : [
            {
                'numProc' : 'Procedimiento de Invitación a Cuando Menos Tres Personas núm. SOPOT-GEH-FAFEF-ITP-1/2022',
                'vigenciaProc' : 'Vigencia: 23 de mayo de 2022 (único día)',
                'descripcionProc' : 'Rehabilitación del puente acceso a Providencia, municipio de Mineral de la Reforma; ubicado en la localidad de La Providencia Siglo XXI, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                'urlAnexosProc' : `${ ligabase }1/1.rar`,
                'resultadosProc' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlResultado' : `${ ligabase }1/JA1.pdf.rar`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlResultado' : `${ ligabase }1/AMD1.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlResultado' : `${ ligabase }1/AP1.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlResultado' : `${ ligabase }1/FA1.pdf`,
                    },
                ]
            }
        ]
    },
]